import React from 'react';
import {
	useEffect,
	useRef,
	useState,
} from 'react';

import {
	Container,
	Alert,
	TabContent,
	TabPane,
} from "reactstrap";

import '../../stylesheets/nutrition.scss';

import * as Parts from "../parts/NutritionLabelParts";
import {Equivalents} from "../parts/Equivalents";

import {TABS} from "../../utilities/resources";
import {Bottom} from "../parts/MyTree/Bottom";


const ACTIVE_TAB_CLASSES = "active border border-primary";
const SUB_TABS = [
	"Benefits",
	"Equivalents",
];


export const IndividualBenefits = (
	{
		currency,
		history,
		location,
		projects,
		unitType,
	}
) => {
	let [message, setMessage] = useState("Loading tree benefits...");
	let [project, setProject] = useState(null);
	let [activeTab, setActiveTab] = useState(1);
	let [activeSubTab, setActiveSubTab] = useState(0);

	let benefitsToDisplayRef = useRef(null);
	let locationForDisplayRef = useRef(null);
	let treeRef = useRef(null);
	let buildingRef = useRef(null);

	useEffect(
		() => {
			if (projects.length) {
				if (location.pathname.includes("report/individual")) {
					const retrieveProjects = async () => {
						let searchParams = new URLSearchParams(location.search);
						let uuid = searchParams.get("uuid");
						let project;
						if (projects.length > 1) {
							let filteredProjects = projects.filter(
								(project) => project.uuid === uuid
							);
							project = filteredProjects[0]
						} else {
							project = projects[0];
						}
						if (project.error) {
							setMessage(project.error)
						} else {
							if (project.benefits.calculated) {
								let {
									benefits,
									futureBenefits,
									tree,
									building,
									location,
								} = project;

								treeRef.current = tree;
								buildingRef.current = building;

								if (typeof location.getAbbreviatedLocation !== "undefined") {
									locationForDisplayRef.current = location.getAbbreviatedLocation();
								}

								if (activeTab === 0) {
									benefitsToDisplayRef.current = {...benefits};
								} else {
									benefitsToDisplayRef.current = {...futureBenefits};
								}

								setProject(project);
							}
						}
					}
					retrieveProjects();
				}
			}
		},
		[
			location.pathname,
			location.search,
			activeTab,
			projects,
		]
	);

	useEffect(
		() => {
			if (project) {
				let searchParams = `?era=${activeTab === 0 ? "current" : "forecast"}&type=${activeSubTab === 0 ? "benefits" : "equivalents"}&uuid=${project.uuid}`;
				history.push(
					`${location.pathname}${searchParams}`
				);
			}
		},
		[
			activeSubTab,
			activeTab,
			project,
			history,
			location.pathname,
		]
	);

	const toggle = (tab) => {
		setActiveTab(tab);
	};

	const toggleSubTab = (tab) => {
		setActiveSubTab(tab);
	};

	if (project) {
		return (
			<React.Fragment>
				{project.error ?
					<Alert color={"danger"}>
						{project.error}
					</Alert>
					:
					null
				}
				<Parts.Controls
					toggleFunction={toggle}
					id={"benefitsYearToggle"}
					selected={activeTab}
					settings={TABS}
				/>
				<Parts.TabToggle
					function={toggleSubTab}
					selected={activeSubTab}
					tabs={SUB_TABS}
					activeTabClasses={ACTIVE_TAB_CLASSES}
				/>
				<TabContent
					activeTab={activeSubTab}
					className={"nutrition"}
				>
					<TabPane tabId={0}>
						<Container
							id={`${activeTab === 0 ? "now" : "future"}-benefits`}>
							<Parts.Header
								activeTab={activeTab}
							/>
							<Parts.TreeName
								name={project.note}
								common={treeRef.current.common}
								scientific={treeRef.current.scientific}
							/>
							<Parts.ServingSize
								diameter={treeRef.current.diameter}
								unitType={unitType}
							/>
							<Parts.Condition
								condition={treeRef.current.getVerboseCondition()}
							/>
							{locationForDisplayRef.current.length ?
								<Parts.Location
									location={locationForDisplayRef.current}
								/>
								:
								null
							}
							<Parts.Annual
								tab={activeTab}
								location={project.location}
								currency={currency}
								value={
									benefitsToDisplayRef.current.totalDollarValue(
										buildingRef.current.proximity === 0
									)
								}
							/>
							<Parts.BenefitsTable
								tab={activeTab}
								unitType={unitType}
								currency={currency}
								benefits={benefitsToDisplayRef.current}
								proximity={buildingRef.current.proximity}
							/>
						</Container>
					</TabPane>
					<TabPane tabId={1}>
						<Equivalents
							id={`${activeTab === 0 ? "now" : "future"}-equivalents`}
							scientific={treeRef.current.scientific}
							activeTab={activeTab}
							benefits={benefitsToDisplayRef.current}
							common={treeRef.current.common}
							locationForDisplay={locationForDisplayRef.current.length ? locationForDisplayRef.current : null}
							name={project.note}
							unitType={unitType}
						>
							{{
								intro:
									<p className={"h5 fw-bold text-center mt-3"}>
										With care and maintenance,<br/>
										after {activeTab === 0 ? "1 year" : "20 years"}{" "}
										this tree<br/>could potentially:
									</p>,
								label: <div>
									<p className={"h3 fw-bold"}>
										MyTree
									</p>
									<p className={"mt-n2 h5 fw-bold"}>
										Works hard for me!
									</p>
								</div>,
							}}
						</Equivalents>
					</TabPane>
					<Bottom
						activeTab={activeTab}
						activeSubTab={activeSubTab}
						dbVersion={benefitsToDisplayRef.current.meta.dbVersion}
						engineVersion={benefitsToDisplayRef.current.meta.engineVersion}
						tree={treeRef.current}
						url={project.__url()}
						warning={project.warning}
					/>
				</TabContent>
			</React.Fragment>
		);
	} else {
		return (
			<div
				className={"mt-5 px-5 d-flex justify-content-center align-items-center"}>
				<h3>{message}</h3>
			</div>
		);
	}
};
